import { Button as ButtonComponent } from '@/components/ui/button'
import { ButtonProps } from '@/types'
import type { WinningCopy } from '../../hooks/useWinningCopy'

const Button = ButtonComponent as React.FC<
    ButtonProps & Pick<React.ButtonHTMLAttributes<HTMLButtonElement>, 'type' | 'aria-label'>
>

interface WinningCopyChipsProps {
    copies: WinningCopy[]
    onPick: (copy: WinningCopy) => void
}

const labelOf = (copy: WinningCopy) => [copy.headline, copy.primaryText].filter(Boolean).join(' | ')

/** Pick-to-fill chips: the winning copy of the licence's own ads that generation uses, one chip each. */
export const WinningCopyChips = ({ copies, onPick }: WinningCopyChipsProps) => {
    if (copies.length === 0) return null
    return (
        <div className="tw:mb-6 tw:flex tw:flex-col tw:gap-2" data-testid="winning-copy-chips">
            <span className="tw:text-sm tw:font-bold">From what worked</span>
            <span className="tw:text-xs tw:text-gray-200">
                Copy from your own ads that did best. Pick one to fill it in, then edit it freely.
            </span>
            <div className="tw:flex tw:flex-wrap tw:gap-2">
                {copies.map((copy) => (
                    <Button
                        key={copy.key}
                        type="button"
                        variant="secondary"
                        size="sm"
                        className="tw:h-auto tw:max-w-full tw:whitespace-normal tw:text-left"
                        aria-label={`Use winning copy: ${labelOf(copy)}`}
                        onClick={() => onPick(copy)}
                    >
                        {labelOf(copy)}
                    </Button>
                ))}
            </div>
        </div>
    )
}
